import { useEffect, useState, useRef, useMemo } from "react";
import SurveyListHeader from "../../../../../component/common/layout/SurveyListHeader";
import SurveyListSidebar from "../../../../../component/common/layout/SurveyListSidebar";
import ConfigurationSidebar from "../../../../../component/common/layout/ConfigurationSidebar";
import CreatableSelect from "react-select/creatable";

import DataTable from "react-data-table-component";
import Svg from "../../../../../component/common/Svg";

import SearchInput from "../../../../../core/Inputs/SearchInput";
import Card from "../../../../../core/Card/Card";
import style from "../../../../style.module.css";
import Input from "../../../../../core/Inputs/DefaultInput";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import useVerifySurveyId from "../../../../../hooks/verifySurveyId";
import Select from "react-select";
import { toast } from "react-toastify";
import { getLeadGenVariable } from "../../../../../store/actions/variableAction";
import {
  getWebhookEvents,
  createWebhook,
  getWebhooks,
  updateWebhook,
  getActiveWebhooks,
  deleteWebhook,
} from "../../../../../store/actions/surveyAction";
import { Formik, Form, FieldArray } from "formik";
import * as Yup from "yup";
//  Bootstrap JS for showing / hiding the existing modal without altering its classes

const SURVEAY_URL = process.env.REACT_APP_USER_LINK;

export default function Webhooks() {
  const { t } = useTranslation();
  const survey_id = useVerifySurveyId();
  const dispatch = useDispatch();

  const [editMode, setEditMode] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [sortBy, setSortBy] = useState("recent");
  const [selectedDeleteRole, setSelectedDeleteRole] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [initialFormValues, setInitialFormValues] = useState({
    webhook_id: "",
    webhooks: "",
    url: "",
    description: "",
    status: "Inactive",
    eventCode: "",
    params: [{ name: "", value: "" }],
    http_method: "",
    content_type: "",
    data_format: "",
  });

  const leadGenData = useSelector((state) => state?.variables?.leadGenData);
  const webhookEvents = useSelector(
    (state) => state?.surveyData?.webhookEvents || []
  );
  const webhookList = useSelector(
    (state) => state?.surveyData?.webhookList || []
  );
  const { survey_name } = useSelector((state) => state.permissionsData);
  const webhookActiveList = useSelector(
    (state) => state?.surveyData?.webhookActiveList || []
  );

  console.log(webhookEvents, "webhookEvents");
  console.log(webhookEvents, "webhookList");
  console.log(webhookActiveList, "webhookActiveList");

  useEffect(() => {
    if (survey_id) {
      dispatch(getLeadGenVariable(survey_id));
      dispatch(getWebhookEvents());
      dispatch(getWebhooks(survey_id));
      dispatch(getActiveWebhooks(survey_id));
    }
  }, [survey_id, dispatch]);

  const filteredWebhooks = useMemo(() => {
    let result = webhookList;

    if (searchText.trim()) {
      const keyword = searchText.trim().toLowerCase();
      result = result.filter(
        (webhook) =>
          webhook.name?.toLowerCase().includes(keyword) ||
          webhook.url?.toLowerCase().includes(keyword) ||
          webhook.description?.toLowerCase().includes(keyword) ||
          webhook.event?.toLowerCase().includes(keyword)
      );
    }

    if (sortBy === "active") {
      result = [...result].sort((a, b) => b.is_active - a.is_active);
    } else if (sortBy === "inactive") {
      result = [...result].sort((a, b) => a.is_active - b.is_active);
    }

    return result;
  }, [searchText, webhookList, sortBy]);

  const staticOptions = [
    { value: "ReportLink", label: "Report Link" },
    { value: "overall_percentage", label: "Overall Percentage" },
    { value: "CompleteStatus", label: "CompleteStatus" },
    { value: "utm_campaign", label: "utm_campaign" },
    { value: "utm_medium", label: "utm_medium" },
    { value: "utm_source", label: "utm_source" },
    { value: "STATIC_FIELD", label: "Static Field" },
  ];

  const httpMethodOptions = [
    { value: "GET", label: "GET" },
    { value: "POST", label: "POST" },
  ];

  const contentTypeOptions = [
    { value: "multipart/form-data", label: "form-data" },
    { value: "application/json", label: "application/json" },
    {
      value: "application/x-www-form-urlencoded",
      label: "application/x-www-form-urlencoded",
    },
  ];

  const dataFormatOptions = [
    { value: "query_params", label: "Query Parameters" },
    { value: "request_body", label: "Request Body" },
  ];

  const eventOptions =
    webhookEvents?.map((event) => ({
      value: event.code,
      label: event.label,
    })) || [];

  const leadGenOptions =
    leadGenData?.map((item) => ({
      value: item?.su_name,
      label: item?.su_name,
    })) || [];
  const allOptions = [...leadGenOptions, ...staticOptions];

  const ParamSchema = Yup.object({
    name: Yup.string().required(t("survey.NRequired")),
    value: Yup.string().required(t("webhook.validation.params_value_required")),
  });

  // const validationSchema = Yup.object({
  //   webhooks: Yup.string().required(t("webhook.validation.name_required")),
  //   url: Yup.string().url("Invalid URL").required(t("webhook.validation.url_required")),
  //   description: Yup.string(),
  //   // status: Yup.string().oneOf(["Active", "Inactive"]).required("Required"),
  //   eventCode: Yup.string().required("Event is required"),
  //   http_method: Yup.string()
  //     .oneOf(["GET", "POST"])
  //     .required(t("webhook.validation.http_method_required")),
  //   content_type: Yup.string().when("http_method", {
  //     is: "POST",
  //     then: (schema) => schema.required(t("webhook.validation.content_type_required")),
  //     otherwise: (schema) => schema.notRequired().nullable(),
  //   }),

  //   data_format: Yup.string().when("http_method", {
  //     is: "POST",
  //     then: (schema) =>
  //       schema
  //         .oneOf(["query_params", "request_body"])
  //         .required(t("webhook.validation.data_format_required")),
  //     otherwise: (schema) =>
  //       schema
  //         .oneOf(["query_params"]) // Only allow query_params for GET
  //         .notRequired()
  //         .nullable(),
  //   }),

  //   params: Yup.array().of(ParamSchema),
  // }).test(
  //   "method-data-format-compatibility",
  //   "GET requests cannot have request body",
  //   function (value) {
  //     if (value.http_method === "GET" && value.data_format === "request_body") {
  //       return this.createError({
  //         message:
  //           "GET requests cannot have request body. Please use Query Parameters for GET requests.",
  //       });
  //     }
  //     return true;
  //   }
  // );


  const validationSchema = Yup.object({
  webhooks: Yup.string().required(t("webhook.validation.name_required")),
  url: Yup.string()
    .url(t("webhook.validation.url_invalid"))
    .required(t("webhook.validation.url_required")),
  description: Yup.string(),
  eventCode: Yup.string().required(t("webhook.validation.event_required")),
  http_method: Yup.string()
    .oneOf(["GET", "POST"], t("webhook.validation.http_method_oneof"))
    .required(t("webhook.validation.http_method_required")),
  content_type: Yup.string().when("http_method", {
    is: "POST",
    then: (schema) =>
      schema.required(t("webhook.validation.content_type_required")),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),
  data_format: Yup.string().when("http_method", {
    is: "POST",
    then: (schema) =>
      schema
        .oneOf(["query_params", "request_body"], t("webhook.validation.data_format_invalid"))
        .required(t("webhook.validation.data_format_required")),
    otherwise: (schema) =>
      schema
        .oneOf(["query_params"], t("webhook.validation.data_format_invalid")) // Only allow query_params for GET
        .notRequired()
        .nullable(),
  }),
  params: Yup.array().of(ParamSchema),
}).test(
  "method-data-format-compatibility",
  t("webhook.validation.get_no_body"),
  function (value) {
    if (value.http_method === "GET" && value.data_format === "request_body") {
      return this.createError({
        message: t("webhook.validation.get_no_body"),
      });
    }
    return true;
  }
);


  const generateParams = (paramsArray) => {
    if (
      paramsArray.length === 1 &&
      (paramsArray[0].name === "" || paramsArray[0].value === "")
    ) {
      return "";
    }
    const rawParams = paramsArray.map((param, index) => {
      if (paramsArray[index].name === "" || paramsArray[index].value === "") {
        return "";
      }
      return `${param.name}=${param.value}`;
    });
    const params = rawParams.join("&");
    return `&${params}`;
  };

  const getUrl = (formValues) => {
    if (!formValues.url) return "";

    const baseUrl = formValues.url.includes("?")
      ? formValues.url
      : `${formValues.url}?`;

    const rawParams = formValues.params
      .filter((p) => p.name)
      .map((p) => {
        const val =
          p.value === "STATIC_FIELD"
            ? p.staticValue !== undefined
              ? p.staticValue
              : ""
            : p.value !== undefined
            ? p.value
            : "";
        return `${encodeURIComponent(p.name)}=${encodeURIComponent(val)}`;
      })
      .join("&");

    return `${baseUrl}${rawParams}`;
  };

  const generateApiPreview = (formValues) => {
    if (!formValues.url) return "";
    const method = formValues.http_method || "POST";
    const contentType =
      formValues.content_type || "application/x-www-form-urlencoded";
    const dataFormat = formValues.data_format || "query_params";
    let preview = `${method} ${formValues.url}`;
    if (method === "GET" || dataFormat === "query_params") {
      const params = formValues.params
        .filter((p) => p.name)
        .map((p) => {
          const val =
            p.value === "STATIC_FIELD"
              ? p.staticValue !== undefined
                ? p.staticValue
                : ""
              : p.value !== undefined
              ? p.value
              : "";
          return `${p.name}=${val}`;
        })
        .join("&");
      if (params) {
        preview += `?${params}`;
      }
    }
    if (method !== "GET") {
      preview += `\nContent-Type: ${contentType}`;
    }
    if (method === "POST" && dataFormat === "request_body") {
      if (
        contentType === "multipart/form-data" ||
        contentType === "form-data"
      ) {
        preview += "\n\n";
        formValues.params
          .filter((p) => p.name)
          .forEach((p) => {
            const val =
              p.value === "STATIC_FIELD"
                ? p.staticValue !== undefined
                  ? p.staticValue
                  : ""
                : p.value !== undefined
                ? p.value
                : "";
            preview += `${p.name}: ${val}\n`;
          });
      } else if (contentType === "application/json") {
        preview += "\n\n";
        const bodyData = {};
        formValues.params
          .filter((p) => p.name)
          .forEach((p) => {
            bodyData[p.name] =
              p.value === "STATIC_FIELD"
                ? p.staticValue !== undefined
                  ? p.staticValue
                  : ""
                : p.value !== undefined
                ? p.value
                : "";
          });
        preview += JSON.stringify(bodyData, null, 2);
      } else if (contentType === "application/x-www-form-urlencoded") {
        preview += "\n\n";
        const bodyData = formValues.params
          .filter((p) => p.name)
          .map((p) => {
            const val =
              p.value === "STATIC_FIELD"
                ? p.staticValue !== undefined
                  ? p.staticValue
                  : ""
                : p.value !== undefined
                ? p.value
                : "";
            return `${p.name}=${val}`;
          })
          .join("&");
        preview += bodyData;
      }
    }
    return preview;
  };

  const columns = [
    {
      name: "Webhook",
      selector: (row) => row.name,
    },
    {
      name: "URL",
      cell: (row) => (
        <a
          className="action-btn-stroke"
          href={row.webhook_url}
          title={row.webhook_url}
          target="_blank"
          rel="noreferrer"
        >
          <Svg name="link" />
        </a>
      ),
    },
    {
      name: t("survey.status"),
      cell: (row) => (
        <span
          className={"table-status " + (row.is_active ? "Active" : "Inactive")}
        >
          {row.is_active ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      name: t("survey.customVariable.action"),
      cell: (row) => (
        <div className="d-flex action-wrapper">
          {window.modulePermissions.M18.edit == 1 && (<a
            href="#"
            className="action-btn"
            onClick={(e) => {
              e.preventDefault();
              setEditMode(true);
              setInitialFormValues({
                webhook_id: row.webhook_id,
                webhooks: row.name,
                url: row.url,
                description: row.description,
                status: row.is_active ? "Active" : "Inactive",
                eventCode: row.event,
                params: (row.variables
                  ? JSON.parse(row.variables)
                  : [{ name: "", value: "" }]
                ).map((param) => {
                  if (param.type === "STATIC_FIELD") {
                    return {
                      name: param.name,
                      value: "STATIC_FIELD",
                      staticValue: param.value,
                    };
                  }
                  return { name: param.name, value: param.value };
                }),
                http_method: row.http_method || "POST",
                content_type:
                  row.content_type || "application/x-www-form-urlencoded",
                data_format: row.data_format || "query_params",
              });
              setIsModalOpen(true);
            }}
          >
            <Svg name="table-edit" />
          </a>)}
          {window.modulePermissions.M18.del == 1 && (<a
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#deleteModal"
            className="action-btn"
            onClick={() => setSelectedDeleteRole(row.webhook_id)}
          >
            <Svg name="table-delete" />
          </a>)}
        </div>
      ),
    },
  ];

  const handleSubmit = (values) => {
    // Map params to use staticValue if value is STATIC_FIELD, and add type for static fields
    const payloadParams = values.params.map((param) => {
      if (param.value === "STATIC_FIELD") {
        return {
          name: param.name,
          value: param.staticValue,
          type: "STATIC_FIELD",
        };
      }
      return { name: param.name, value: param.value };
    });
    const payload = {
      webhook_id: values.webhook_id,
      survey_id,
      name: values.webhooks,
      event: values.eventCode,
      url: values.url,
      webhook_url: getUrl({ ...values, params: payloadParams }),
      description: values.description,
      variables: payloadParams.length ? JSON.stringify(payloadParams) : "[]",
      is_active: values.status === "Active" ? 1 : 0,
      http_method: values.http_method,
      content_type: values.content_type,
      data_format: values.data_format,
    };
    console.log(payload, "payyyyyyyyyyyyyyyyy");
    if (editMode) {
      dispatch(
        updateWebhook(payload, survey_id, values.webhook_id, () => {
          dispatch(getWebhooks(survey_id));
          toast.success("Webhook updated successfully");
          setIsModalOpen(false);
        })
      );
    } else {
      dispatch(
        createWebhook(payload, () => {
          dispatch(getWebhooks(survey_id));
          toast.success("Webhook created successfully");
          setIsModalOpen(false);
        })
      );
    }
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper bg-white">
        <SurveyListHeader />
        <div
          id="viewport"
          className="flex-grow-1 d-flex survey-main-wrapper bg-white"
        >
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            {/* <ConfigurationSidebar /> */}
            <div className="flex-grow-1 page-content-wrap d-flex flex-column">
              <div className="page-heading d-flex align-items-center">
                <div className="flex-grow-1">
                  {/* breadcrumbs here */}
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/admin/survey/list">
                          {t("survey.title")}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link
                          to={`/admin/survey/create/qa-builder?survey_id=${survey_id}`}
                        >
                          {survey_name}
                        </Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        <strong>{t("webhook.webhook")}</strong>
                      </li>
                    </ol>
                  </nav>
                  <h1>{t("webhook.title")}</h1>
                </div>
                {window.modulePermissions.M18.add == 1 && (<div className="button-wrap">
                  <button
                    type="button"
                    className="btn btn-primary add-btn"
                    onClick={() => {
                      setEditMode(false);
                      setInitialFormValues({
                        webhooks: "",
                        url: "",
                        description: "",
                        status: "Inactive",
                        eventCode: eventOptions[0]?.value ?? "",
                        params: [{ name: "", value: "" }],
                        http_method: "",
                        content_type: "",
                        data_format: "",
                      });
                      setIsModalOpen(true);
                    }}
                  >
                    <Svg name="plus" /> {t("webhook.add")}
                  </button>
                </div>)}
              </div>

              {/* ===== table ===== */}
              <div className="role-wrapper flex-grow-1">
                <div className="table-wrapper-view">
                  <div className="search-filter d-md-flex align-items-center">
                    <div className="flex-grow-1 search-filter-padding">
                      <SearchInput
                        className="custom-search-input"
                        type="def"
                        view="outlined"
                        color="primary"
                        placeholder={t("settings.users_and_teams.users.search")}
                        fill={true}
                        value={searchText}
                        onChange={(e) => handleSearch(e.target.value)}
                        onClear={() => handleSearch("")}
                      />
                    </div>
                    <div className="drop-wrap d-flex align-items-center">
                      <label>{t("settings.team.sort_by")} - </label>
                      <div className="dropdown table-dropdown ques-options">
                        <button
                          className="btn dropdown-tgl"
                          type="button"
                          id="languages"
                          data-bs-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {sortBy === "recent"
                            ? t("webhook.recently")
                            : sortBy === "active"
                            ? t("webhook.active")
                            : t("webhook.inactive")}
                        </button>
                        <div
                          className="dropdown-menu"
                          aria-labelledby="languages"
                        >
                          {/* <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setSortBy("recent"); }}>
                            Recently added
                          </a> */}
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setSortBy("active");
                            }}
                          >
                            {t("webhook.active")}
                          </a>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setSortBy("inactive");
                            }}
                          >
                            {t("webhook.inactive")}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-wrap custom-data-table">
                    <DataTable columns={columns} data={filteredWebhooks} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* === modal markup (classes unchanged) === */}
      {isModalOpen && (
        <div
          className="modal fade setting-modal show d-block"
          id="addWebhookModal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="addWebhookModalLabel"
          aria-modal="true"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-body">
                <div>
                  <div>
                    <div className="modal-heading">
                      <h4>
                        {editMode ? t("webhook.editTitle") : t("webhook.createTitle")}
                      </h4>
                    </div>

                    {/* === FORM === */}
                    <Formik
                      initialValues={initialFormValues}
                      enableReinitialize
                      validationSchema={validationSchema}
                      onSubmit={handleSubmit}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        setFieldValue,
                        setFieldTouched,
                      }) => (
                        <Form className="form-wrapper input-margin-zero mt-3">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group mb-3 position-relative">
                                <label>
                                  {t("survey.customVariable.name")}<span className="text-primary">*</span>
                                </label>
                                <Input
                                  type="text"
                                  name="webhooks"
                                  view="outlined"
                                  dense={false}
                                  color="default"
                                  placeholder={t("webhook.name")}
                                  value={values.webhooks}
                                  onChange={handleChange}
                                  fill={true}
                                  className="formsinput"
                                />
                                {touched.webhooks && errors.webhooks && (
                                  <div className="validation-msg">
                                    {errors.webhooks}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="position-relative cstom-select form-group mb-3">
                                <label> {t("webhook.event")}</label>
                                <Select
                                  name="eventCode"
                                  classNamePrefix="react-select"
                                  options={eventOptions}
                                  value={
                                    eventOptions.find(
                                      (opt) => opt.value === values.eventCode
                                    ) || null
                                  }
                                  onChange={(selected) => {
                                    setFieldValue(
                                      "eventCode",
                                      selected?.value || ""
                                    );
                                  }}
                                  onBlur={() => {
                                    // Mark it as touched manually
                                    setFieldTouched("eventCode", true);
                                  }}
                                  placeholder={t("survey.select")}
                                />
                                {touched.eventCode && errors.eventCode && (
                                  <div className="validation-msg">
                                    {errors.eventCode}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-4">
                              <div className="position-relative cstom-select form-group mb-3">
                                <label>{t("webhook.method")}<span className="text-primary">*</span></label>
                                <Select
                                  classNamePrefix="react-select"
                                  options={httpMethodOptions}
                                  value={
                                    httpMethodOptions.find(
                                      (opt) => opt.value === values.http_method
                                    ) || null
                                  }
                                  onChange={(selected) => {
                                    const newMethod = selected?.value || "POST";
                                    setFieldValue("http_method", newMethod);

                                    // Auto-adjust data format for GET requests
                                    if (
                                      newMethod === "GET" &&
                                      values.data_format === "request_body"
                                    ) {
                                      setFieldValue(
                                        "data_format",
                                        "query_params"
                                      );
                                    }
                                    // Clear Content-Type if GET is selected
                                    if (newMethod === "GET") {
                                      setFieldValue("content_type", "");
                                    }
                                  }}
                                  onBlur={() => {
                                    setFieldTouched("http_method", true);
                                  }}
                                  placeholder={t("survey.select")}
                                />
                                {touched.http_method && errors.http_method && (
                                  <div className="validation-msg">
                                    {errors.http_method}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="position-relative cstom-select form-group mb-3">
                                <label>{t("webhook.content_type")}<span className="text-primary">*</span></label>
                                <Select
                                  classNamePrefix="react-select"
                                  options={
                                    values.http_method === "GET"
                                      ? [{ value: "", label: "None" }]
                                      : contentTypeOptions
                                  }
                                  value={
                                    values.http_method === "GET"
                                      ? { value: "", label: "None" }
                                      : contentTypeOptions.find(
                                          (opt) =>
                                            opt.value === values.content_type
                                        ) || null
                                  }
                                  onChange={(selected) => {
                                    setFieldValue(
                                      "content_type",
                                      selected?.value || ""
                                    );
                                  }}
                                  onBlur={() => {
                                    setFieldTouched("content_type", true);
                                  }}
                                  placeholder={t("survey.select")}
                                />
                                {touched.content_type &&
                                  errors.content_type && (
                                    <div className="validation-msg">
                                      {errors.content_type}
                                    </div>
                                  )}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="position-relative cstom-select form-group mb-3">
                                <label>{t("webhook.data_format")}<span className="text-primary">*</span></label>
                                {/* <Select
                                    classNamePrefix="react-select"
                                    options={
                                      values.http_method === "GET"
                                        ? [
                                            {
                                              value: "query_params",
                                              label: "Query Parameters",
                                            },
                                          ]
                                        : dataFormatOptions
                                    }
                                    value={
                                      (values.http_method === "GET"
                                        ? {
                                            value: "query_params",
                                            label: "Query Parameters",
                                          }
                                        : dataFormatOptions.find(
                                            (opt) =>
                                              opt.value === values.data_format
                                          )) || null
                                    }
                                    onChange={(selected) => {
                                      setFieldValue(
                                        "data_format",
                                        selected?.value || "query_params"
                                      );
                                    }}
                                    onBlur={() => {
                                      setFieldTouched("data_format", true);
                                    }}
                                    placeholder="Select Data Format"
                                  /> */}

                                <Select
                                  classNamePrefix="react-select"
                                  options={
                                    values.http_method === "GET"
                                      ? [
                                          {
                                            value: "query_params",
                                            label: "Query Parameters",
                                          },
                                        ]
                                      : dataFormatOptions
                                  }
                                  value={
                                    values.http_method === "GET"
                                      ? dataFormatOptions.find(
                                          (opt) =>
                                            opt.value === values.data_format
                                        ) || null
                                      : dataFormatOptions.find(
                                          (opt) =>
                                            opt.value === values.data_format
                                        ) || null
                                  }
                                  onChange={(selected) => {
                                    setFieldValue(
                                      "data_format",
                                      selected?.value || ""
                                    );
                                  }}
                                  onBlur={() => {
                                    setFieldTouched("data_format", true);
                                  }}
                                  placeholder={t("survey.select")}
                                />

                                {touched.data_format && errors.data_format && (
                                  <div className="validation-msg">
                                    {errors.data_format}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className=" position-relative form-group mb-3">
                            <label>{t("webhook.url")}<span className="text-primary">*</span></label>
                            <Input
                              type="text"
                              name="url"
                              view="outlined"
                              dense={false}
                              color="default"
                              placeholder={t("webhook.example")}
                              value={values.url}
                              onChange={window.modulePermissions.M18.edit == 1 ? handleChange : undefined}
                              fill={true}
                              className="formsinput"
                              readOnly={window.modulePermissions.M18.edit != 1}
                            />
                            {touched.url && errors.url && (
                              <div className="validation-msg">{errors.url}</div>
                            )}
                          </div>

                          <div className="form-group mb-3">
                            <label>
                              {t("survey.customVariable.description")}
                            </label>
                            <textarea
                              className="form-control"
                              name="description"
                              placeholder={t("webhook.desc")}
                              value={values.description}
                              onChange={window.modulePermissions.M18.edit == 1 ? handleChange : undefined}
                              readOnly={window.modulePermissions.M18.edit != 1}
                            />
                          </div>

                          {/* Parameters using FieldArray */}
                          <div className="parameter-add-fields">
                            <label>{t("survey.share.Parameters")}<span className="text-primary">*</span></label>
                            <FieldArray name="params">
                              {({ push, remove }) => (
                                <>
                                  {values.params.map((param, index) => (
                                    <div className="d-flex" key={index}>
                                      <div className="flex-grow-1">
                                        <div className="d-flex flex-wrap gap-3">
                                          <div className="flex-grow-1">
                                            <div className="mb-3 position-relative">
                                              <Input
                                                type="text"
                                                name={`params[${index}].name`}
                                                view="outlined"
                                                color="default"
                                                placeholder={t(
                                                  "survey.customVariable.name"
                                                )}
                                                fill
                                                className="formsinput"
                                                value={
                                                  values.params[index].name
                                                }
                                                onChange={handleChange}
                                              />
                                              {touched.params?.[index]?.name &&
                                                errors.params?.[index]
                                                  ?.name && (
                                                  <div className="validation-msg">
                                                    {errors.params[index].name}
                                                  </div>
                                                )}
                                            </div>
                                          </div>
                                          <div className="flex-grow-1">
                                            <div className="mb-3 cstom-select position-relative">
                                              <Select
                                                classNamePrefix="react-select"
                                                options={allOptions}
                                                value={
                                                  allOptions.find(
                                                    (opt) =>
                                                      opt.value ===
                                                      values.params[index].value
                                                  ) || null
                                                }
                                                onChange={(selected) => {
                                                  setFieldValue(
                                                    `params[${index}].value`,
                                                    selected?.value || ""
                                                  );
                                                  // If not static field, clear staticValue
                                                  if (
                                                    selected?.value !==
                                                    "STATIC_FIELD"
                                                  ) {
                                                    setFieldValue(
                                                      `params[${index}].staticValue`,
                                                      ""
                                                    );
                                                  }
                                                }}
                                                placeholder={t("survey.select")}
                                              />
                                              {touched.params?.[index]?.value &&
                                                errors.params?.[index]
                                                  ?.value && (
                                                  <div className="validation-msg">
                                                    {errors.params[index].value}
                                                  </div>
                                                )}
                                            </div>
                                          </div>
                                          {values.params[index].value ===
                                            "STATIC_FIELD" && (
                                            <div className="flex-grow-1">
                                              <div className="mb-3 position-relative">
                                                <Input
                                                  type="text"
                                                  name={`params[${index}].staticValue`}
                                                  fill
                                                  placeholder="Enter static value"
                                                  value={
                                                    values.params[index]
                                                      .staticValue || ""
                                                  }
                                                  onChange={handleChange}
                                                  className="formsinput"
                                                />
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                      <div className="button-wrap mb-3 d-flex align-items-start button-box">
                                        {index === values.params.length - 1 ? (
                                          <>
                                            <button
                                              className="btn btn-link text-danger"
                                              type="button"
                                              title={t("survey.share.add")}
                                              onClick={() =>
                                                push({ name: "", value: "" })
                                              }
                                            >
                                              <Svg name="plus-icn" />
                                              {/* {t("survey.share.add")} */}
                                            </button>
                                            {values.params.length > 1 && (
                                              <button
                                                className="btn btn-link text-secondary"
                                                type="button"
                                                title={t("webhook.remove")}
                                                onClick={() => remove(index)}
                                              >
                                                <Svg name="remove-icn" />
                                              </button>
                                            )}
                                          </>
                                        ) : (
                                          <button
                                            className="btn btn-link text-secondary"
                                            type="button"
                                            title={t("webhook.remove")}
                                            onClick={() => remove(index)}
                                          >
                                            <Svg name="remove-icn" />
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  ))}
                                </>
                              )}
                            </FieldArray>
                          </div>
                          {values.data_format === "query_params" ? (
                            <div className="generated-url">
                              <div className="mb-3">
                                <label className="form-label-custom">
                                  {t("webhook.generateURl")}
                                </label>
                                <textarea
                                  className="form-control"
                                  rows="2"
                                  readOnly
                                  value={getUrl(values)}
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="api-preview">
                              <div className="mb-3">
                                <label className="form-label-custom">
                                  {t("survey.builder.preview")}
                                </label>
                                <textarea
                                  className="form-control"
                                  rows="8"
                                  readOnly
                                  value={generateApiPreview(values)}
                                  style={{
                                    fontFamily: "monospace",
                                    fontSize: "12px",
                                  }}
                                />
                              </div>
                            </div>
                          )}

                          <div className="form-group mb-3">
                            <label className="form-label-custom">
                              {" "}
                              {t("survey.status")}
                            </label>
                            <div className="d-flex align-items-center flex-wrap form-check-list">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="status"
                                  id="statusActive"
                                  value="Active"
                                  checked={values.status === "Active"}
                                  onChange={handleChange}
                                  disabled={window.modulePermissions.M18.edit != 1}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="statusActive"
                                >
                                  {t("webhook.active")}
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="status"
                                  id="statusInactive"
                                  value="Inactive"
                                  checked={values.status === "Inactive"}
                                  onChange={handleChange}
                                  disabled={window.modulePermissions.M18.edit != 1}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="statusInactive"
                                >
                                  {t("webhook.inactive")}
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="button-wrap d-flex justify-content-end">
                            <button
                              className="btn btn-bordered"
                              type="button"
                              onClick={() => setIsModalOpen(false)}
                            >
                              {t("survey.customVariable.cancel")}
                            </button>
                            {window.modulePermissions.M18.edit == 1 && <button
                              className="btn btn-primary add-btn ms-3"
                              type="submit"
                            >
                              <Svg name="plus" />{" "}
                              {editMode
                                ? t("survey.share.update")
                                : t("survey.share.add")}
                            </button>}
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div
        className="customvar-modal modal custom-modal fade deleteModal"
        id="deleteModal"
        tabIndex={-1}
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div
                className={
                  "formvawrapper delete-modal-wrap modal-setting-medium"
                }
              >
                <div className={"formstyle p-0"}>
                  <div className="delete-body-wrap delete-language">
                    <div className="heading">
                      <h3>{t("webhook.delete")}</h3>
                      <p>{t("webhook.delete1")}</p>
                    </div>

                    <div className="button-wrap d-flex justify-content-end">
                      {window.modulePermissions.M18.del == 1 && (<button
                        type="button"
                        className="btn btn-delete"
                        data-bs-dismiss="modal"
                        onClick={() => {
                          if (selectedDeleteRole && survey_id) {
                            dispatch(
                              deleteWebhook(
                                survey_id,
                                selectedDeleteRole,
                                () => {
                                  dispatch(getWebhooks(survey_id));
                                  setSelectedDeleteRole(null);
                                }
                              )
                            );
                          }
                        }}
                      >
                        {t("settings.roles.delete_action.delete")}
                      </button>)}

                      <button
                        type="button"
                        className="btn btn-bordered color-cancel ms-3"
                        data-bs-dismiss="modal"
                      >
                        {t("settings.roles.delete_action.cancel")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

